export const riskMapping = {
  "Goal A1:": [
    {
      risk: "Omission of comprehensive impact assessment for AI deployment.",
      detail: "AI system is implemented without stakeholder impact screening or patient safety pre-checks.",
      reference: "Entry #201 (“Incomplete impact assessment before deployment leads to negative patient outcomes”), Slattery et al, p. 17."
    },
    {
      risk: "Superficial or template-only assessments.",
      detail: "Impact assessments made as check-box exercises without depth or follow-up.",
      reference: "Entry #202, Slattery et al, p. 18."
    },
    {
      risk: "Exclusion of stakeholder voices.",
      detail: "Limited engagement of affected parties leading to blind spots.",
      reference: "Entry #203, Slattery et al, p. 18."
    },
    {
      risk: "Failing to consider long-term or indirect impacts.",
      detail: "Neglecting secondary socio-economic harms or environmental impacts.",
      reference: "Entry #208, Slattery et al, p. 18."
    },
    {
      risk: "Inadequate post-deployment review.",
      detail: "No follow-up assessment to capture emerging harms or system drift.",
      reference: "Entry #211, Slattery et al, p. 18."
    }
  ],

  "Goal A2:": [
    {
      risk: "No escalation protocol for documented harms.",
      detail: "Harmful events are not formally escalated for organizational response or review.",
      reference: "Entry #326, Slattery et al, p. 22."
    },
    {
      risk: "No independent adverse impact review board.",
      detail: "Absence of external or third-party harms oversight committee.",
      reference: "Entry #329, Slattery et al, p. 22."
    },
    {
      risk: "Unrecorded or unreported adverse events.",
      detail: "Incomplete documentation and concealment of AI failures or damages.",
      reference: "Entry #331, Slattery et al, p. 22."
    },
    {
      risk: "Failure to run regular external audits.",
      detail: "Lack of systematic independent audits limits detection of systemic harms.",
      reference: "Entry #333, Slattery et al, p. 23."
    }
  ],

  "Goal A3:": [
    {
      risk: "Model repurposed beyond validated domain.",
      detail: "Algorithm designed for finance improperly reused in healthcare diagnostics causing misclassifications.",
      reference: "Entry #142, Slattery et al, p. 9."
    },
    {
      risk: "Model drift and performance decay.",
      detail: "Degradation over time due to changes in data distribution or environment.",
      reference: "Entry #143, Slattery et al, p. 9."
    },
    {
      risk: "Deployment in mismatched contexts.",
      detail: "Use of models in contexts fundamentally different from training conditions without revalidation.",
      reference: "Entry #147, Slattery et al, p. 10."
    },
    {
      risk: "Lack of domain expert oversight.",
      detail: "Insufficient expert review leading to missed domain-specific risks or errors.",
      reference: "Entry #149, Slattery et al, p. 10."
    }
    
  ],

  "Goal A4:": [
    {
      risk: "Poor auditability and incomplete lineage tracking.",
      detail: "Data sources for facial recognition system are undocumented, leading to unknown systemic biases.",
      reference: "Entry #108 (“Lack of data governance results in untraceable errors and bias propagation”), Slattery et al, p. 7."
    },
    {
      risk: "Weak controls on data quality or bias.",
      detail: "Insufficient processes to ensure dataset accuracy and fairness before use.",
      reference: "Entry #112, Slattery et al, p. 8."
    },
    {
      risk: "Retention of non-essential personal data.",
      detail: "Data withholding beyond necessary scope increases privacy risks.",
      reference: "Entry #116, Slattery et al, p. 8."
    },
    {
      risk: "Failure to update datasets for population/context changes.",
      detail: "Stale data fails to reflect modern reality, producing biased or invalid outputs.",
      reference: "Entry #118, Slattery et al, p. 8."
    },
    
  ],
  
  "Goal A5:": [
    {
      risk: "AI decisions not reviewable by humans.",
      detail: "No human-in-the-loop or override mechanisms for critical decisions.",
      reference: "Entry #239, Slattery et al, p. 15."
    },
    {
      risk: "No override or fallback mechanism.",
      detail: "Lack of system provisions for manual intervention in failure or unexpected scenarios.",
      reference: "Entry #241, Slattery et al, p. 15."
    },
    {
      risk: "Ambiguous or fragmented accountability.",
      detail: "Unclear responsibility undermines response to AI failures or harms.",
      reference: "Entry #243, Slattery et al, p. 15."
    },
    
    
  ],

  "Goal T1:": [
    {
      risk: "Opaque model architecture and lack of explanations.",
      detail: "Black-box AI systems prevent understanding and challenge external auditing or trust.",
      reference: "Entry #521, Slattery et al, p. 31."
    },
    {
      risk: "Stakeholders denied access to model logic.",
      detail: "Limited transparency restricts trust and due diligence on AI decisions.",
      reference: "Entry #523, Slattery et al, p. 31."
    },
    {
      risk: "No explainability tooling provided.",
      detail: "No mechanisms offered to clarify AI decision processes to end users or inspectors.",
      reference: "Entry #524, Slattery et al, p. 32."
    },
    
  ],

  "Goal T2:": [
    {
      risk: "Missing communication of error rates and limitations.",
      detail: "Stakeholders unaware of AI risks or accuracy constraints.",
      reference: "Entry #389, Slattery et al, p. 19."
    },
    {
      risk: "No plain-language documentation for end users.",
      detail: "Technical models explained only in complex terms inaccessible to most stakeholders.",
      reference: "Entry #391, Slattery et al, p. 19."
    },
    {
      risk: "Insufficient risk reporting in compliance filings.",
      detail: "Regulatory submissions omit key risk information impacting oversight.",
      reference: "Entry #393, Slattery et al, p. 19."
    },
    {
      risk: "Promotional materials misrepresent capabilities.",
      detail: "Marketing claims often exaggerate or omit key operational limits or risks.",
      reference: "Entry #395, Slattery et al, p. 19."
    },
    
  ],

  "Goal T3:": [
    {
      risk: "User not informed about automated processes.",
      detail: "System fails to notify users when interacting with AI rather than humans.",
      reference: "Entry #412, Slattery et al, p. 21."
    },
    {
      risk: "Lack of logs or records of AI-mediated interventions.",
      detail: "No history maintained to audit or analyse AI user interactions.",
      reference: "Entry #414, Slattery et al, p. 21."
    },
    {
      risk: "Ambiguous wording about system automation.",
      detail: "Lack of clarity whether AI involvement is present, causing confusion or mistrust.",
      reference: "Entry #416, Slattery et al, p. 21."
    }
    
  ],

  "Goal F1:": [
    {
      risk: "Disparities in error rates for marginalized groups.",
      detail: "Voice recognition systems fail more often for underrepresented accents, reducing service quality.",
      reference: "Entry #144, Slattery et al, p. 10."
    },
    {
      risk: "Lacking population-wide fairness testing.",
      detail: "Missing comprehensive bias testing across demographics leads to inequitable service.",
      reference: "Entry #146, Slattery et al, p. 10."
    },
    {
      risk: "No protocol for bias remediation.",
      detail: "Discovered service bias is not systematically corrected or mitigated.",
      reference: "Entry #148, Slattery et al, p. 10."
    },
    {
      risk: "Persistent performance divides.",
      detail: "Service delivery remains uneven across social or demographic groups over time.",
      reference: "Entry #150, Slattery et al, p. 11."
    },
    
  ],

  "Goal F2:": [
    {
      risk: "Allocation bias based on historical data.",
      detail: "Resource distribution algorithms replicate systemic inequities from training data.",
      reference: "Entry #468, Slattery et al, p. 24."
    },
    {
      risk: "Exclusion of eligible groups due to skewed eligibility logic.",
      detail: "Eligibility criteria unfairly disqualify or overlook portions of the population.",
      reference: "Entry #471, Slattery et al, p. 25."
    },
    {
      risk: "No documented fairness checks for algorithms.",
      detail: "Lack of audits or transparency obscures bias in allocation outcomes.",
      reference: "Entry #473, Slattery et al, p. 25."
    },
    {
      risk: "Unremediated failure of resource allocation.",
      detail: "Known inequities in allocation remain unaddressed across deployment cycles.",
      reference: "Entry #476, Slattery et al, p. 25."
    }
    
  ],

  "Goal F3:": [
    {
      risk: "Model outputs reinforce harmful stereotypes.",
      detail: "Generative models produce content that perpetuates race, gender, or cultural stereotypes.",
      reference: "Entry #515, Slattery et al, p. 32."
    },
    {
      risk: "Absence of output red-teaming or filtering.",
      detail: "Lack of proactive testing or sanitization allows harmful content to propagate.",
      reference: "Entry #517, Slattery et al, p. 32."
    },
    {
      risk: "Erasure or distortion of minorities in generated content.",
      detail: "AI systematically excludes or distorts representations of minority groups.",
      reference: "Entry #519, Slattery et al, p. 32."
    },
    {
      risk: "Ongoing derogatory outputs.",
      detail: "Repetitive generation of demeaning or derogatory statements without correction.",
      reference: "Entry #520, Slattery et al, p. 32."
    },
    
  ],

  "Goal RS1:": [
    {
      risk: "No documented reliability or safety criteria.",
      detail: "AI system deployed without benchmarks or acceptance thresholds for safety.",
      reference: "Entry #178, Slattery et al, p. 12."
    },
    {
      risk: "Missing model fail-state analysis.",
      detail: "Failure modes remain unidentified before production deployment.",
      reference: "Entry #180, Slattery et al, p. 12."
    },
    {
      risk: "Incomplete safety protocols pre-deployment.",
      detail: "Safety checks and verification are skipped or insufficiently performed.",
      reference: "Entry #182, Slattery et al, p. 13."
    },
    {
      risk: "Absent or unenforced reliability checklists.",
      detail: "No mandatory reliability assessment processes lead to inconsistent practices.",
      reference: "Entry #184, Slattery et al, p. 13."
    },
    
  ],

  "Goal RS2:": [
    {
      risk: "Undocumented system faults.",
      detail: "Failures or errors are hidden or never officially recorded.",
      reference: "Entry #357, Slattery et al, p. 18."
    },
    {
      risk: "No corrective action post incidents.",
      detail: "No mechanisms exist to learn from faults or prevent recurrence.",
      reference: "Entry #360, Slattery et al, p. 18."
    },
    {
      risk: "Persistent vulnerabilities and faults.",
      detail: "Known issues remain unresolved even after being detected.",
      reference: "Entry #362, Slattery et al, p. 19."
    },
    
  ],

  "Goal RS3:": [
    {
      risk: "No post-deployment monitoring.",
      detail: "Systems are run without ongoing checks for drift, error, or misuse.",
      reference: "Entry #284, Slattery et al, p. 16."
    },
    {
      risk: "Lack of error logging or feedback integration.",
      detail: "Feedback from users or logs is not captured or reviewed for improvement.",
      reference: "Entry #286, Slattery et al, p. 16."
    },
    {
      risk: "No user complaint or correction mechanism.",
      detail: "Users have no formal way to report issues or seek remedy.",
      reference: "Entry #288, Slattery et al, p. 16."
    },
    
  ],
  "Goal PS1:": [
    {
      risk: "Unlawful processing/no consent for personal data.",
      detail: "AI systems operate on personal data without legitimate basis or consent.",
      reference: "Entry #108, Slattery et al, p. 7."
    },
    {
      risk: "Data leakage via model output or API.",
      detail: "Sensitive data unintentionally revealed through system interfaces.",
      reference: "Entry #110, Slattery et al, p. 7."
    },
    {
      risk: "Sensitive metadata not redacted.",
      detail: "Identifiable metadata persists in datasets or outputs risking re-identification.",
      reference: "Entry #112, Slattery et al, p. 8."
    },
    {
      risk: "Failure to enforce anonymization in output.",
      detail: "Outputs contain personally identifiable information violating privacy standards.",
      reference: "Entry #114, Slattery et al, p. 8. "
    },
    
  ],
  "Goal PS2:": [
    {
      risk: "No testing for adversarial robustness.",
      detail: "AI systems vulnerable to tampering, poisoning, or exploitation remain untested.",
      reference: "Entry #523, Slattery et al, p. 32."
    },
    {
      risk: "Vulnerable/unprotected endpoints.",
      detail: "Public APIs or interfaces lack authentication or other protective controls.",
      reference: "Entry #525, Slattery et al, p. 32."
    },
    {
      risk: "No threat/vulnerability analysis.",
      detail: "Absence of formal threat modeling increases attack surface.",
      reference: "Entry #527, Slattery et al, p. 32."
    },
    {
      risk: "Untested security policies.",
      detail: "Policies exist but are never enforced or audited.",
      reference: "Entry #529, Slattery et al, p. 32."
    },
    
  ],
  "Goal I1:": [
    {
      risk: "Interface noncompliant with accessibility standards.",
      detail: "User interface fails to meet requirements like WCAG for disabled users.",
      reference: "Entry #211, Slattery et al, p. 14."
    },
    {
      risk: "System excludes neurodiverse/disabled populations.",
      detail: "Design choices limit usability for cognitive or sensory impairments.",
      reference: "Entry #213, Slattery et al, p. 14."
    },
    {
      risk: "No multi-modal support.",
      detail: "Lack of diverse interaction modes (voice, visual, etc.) restricts inclusion.",
      reference: "Entry #215, Slattery et al, p. 14."
    },
    
  ],
  "Goal RM1:": [
    {
      risk: "Absence of comprehensive AI risk register.",
      detail: "No documented inventory of AI risks maintained or reviewed.",
      reference: "Entry #344, Slattery et al, p. 17."
    },
    {
      risk: "Failure to align governance to ISO 31000/IEC 23894.",
      detail: "Risk processes not compliant with international standards.",
      reference: "Entry #346, Slattery et al, p. 17."
    },
    {
      risk: "Infrequent or missing risk review cycles.",
      detail: "Lack of periodic risk reassessment undermines governance.",
      reference: "Entry #349, Slattery et al, p. 17."
    },
    {
      risk: "No documented mitigation or treatment plans.",
      detail: "Absence of defined risk responses inhibits effective control.",
      reference: "Reference: Entry #351, Slattery et al, p. 18."
    },
    
  ],
  "Goal IA1:": [
    {
      risk: "Loss of control over AI systems leading to unintended harmful behaviors.",
      detail: "Autonomous AI decision-making without sufficient human oversight causes adverse societal impacts.",
      reference: "Wirtz, Weyerer & Kehl, 2022 (MIT AI Risk Repository)"
    },
    {
      risk: "Propagation of AI-driven societal biases and discrimination.",
      detail: "AI systems amplify existing social prejudices affecting individuals or groups unfairly.",
      reference: "Wirtz, Weyerer & Kehl, 2022 (MIT AI Risk Repository)"
    },
    {
      risk: "Poorly regulated AI deployment resulting in ethical and governance failures.",
      detail: "Insufficient governance frameworks lead to unaddressed risks and harms in society.",
      reference: "Wirtz, Weyerer & Kehl, 2022 (MIT AI Risk Repository)"
    },
    {
      risk: "Economic disruption and social unrest due to AI automation.",
      detail: "Large-scale job displacement causes societal destabilization and increased inequalities.",
      reference: "Wirtz, Weyerer & Kehl, 2022 (MIT AI Risk Repository)"
    },
    {
      risk: "Risk of AI-enabled information manipulation and misinformation spread.",
      detail: "Targeted disinformation campaigns undermine social trust and cohesion.",
      reference: "Wirtz, Weyerer & Kehl, 2022 (MIT AI Risk Repository)"
    },
    
  ],
  "Goal DQ1:": [
    {
      risk: "Data quality issues due to bias in training datasets.",
      detail: "Use of biased data sources leads to unfair or inaccurate AI model outcomes.",
      reference: "MIT AI Risk Repository, Domain Taxonomy: Discrimination & Toxicity"
    },
    {
      risk: "Data processing errors resulting in model inaccuracies.",
      detail: "Errors introduced during data cleaning or transformation degrade model effectiveness.",
      reference: "MIT AI Risk Repository, Causal Taxonomy: Technological, Data, and Analytical Risks"
    },
    {
      risk: "Inadequate updating of datasets causing outdated or non-representative training.",
      detail: "Failure to reflect current population or contexts leads to model obsolescence and bias.",
      reference: "MIT AI Risk Repository, Domain Taxonomy: AI system safety, failures, & limitations"
    },
    {
      risk: "Lack of transparency and traceability in data lineage.",
      detail: "Poor documentation impedes auditing and correction of data quality issues.",
      reference: "MIT AI Risk Repository, Data Governance and Management subdomain"
    },
    {
      risk: "Insecure data management exposing privacy and security risks.",
      detail: "Vulnerabilities in data handling put sensitive information at risk of leakage.",
      reference: "MIT AI Risk Repository, Privacy & Security domain"
    },
    
  ],
  
};
